export enum AddSmartSearchDialogStep {
  INITIAL = 1,
  NEW_PROPERTY_INVESTMENT_TYPE_SELECTION = 2,
  NEW_PROPERTY_MORTGAGE_PURPOSE_SELECTION = 3,
  NEW_PROPERTY_MAXIMUM_PRICE = 4,
  NEW_PROPERTY_MAXIMUM_PRICE_SPECIFY_SEARCH = 5,
  PROPERTY_SELECTION = 6,
  REMORTGAGE_BORROW_MORE = 7,
  REMORTGAGE_BORROW_MORE_SPECIFY_SEARCH = 8,
  REMORTGAGE_PAY_FASTER = 9,
  REMORTGAGE_PAY_FASTER_SPECIFY_SEARCH = 10,
  SPEAK_TO_AN_EXPERT = 11,
}
